<script>
import con from '@services/connection'
import { user, simulador, configuracoes } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import store from '@state/store'
import EditarAtivo from '@modal/simulador-editar-ativo'
import { GlobalBus } from '@services/bus'
import { MODAL, CLASSES_SIMULADOR, TIPOS_CONFIG_ATIVOS } from '@constants/Text'
import { getNumber, possivelJSON } from '@utils/Format'
import {
  RECOMENDACAO_LABELS,
  RECOMENDACAO_TEXT_COLORS,
} from '@modules/consolidator/constants/recomendacao'
import ClientTags from '@modules/crm/components/client-tags/client-tags.vue'

export default {
  components: {
    Title,
    EditarAtivo,
    ClientTags,
  },
  props: {
    bus: {
      type: Object,
      default: null,
      required: true,
    },
    openClass: {
      type: Boolean,
      default: false,
    },
    plTotal: {
      type: Number,
      default: 0.0,
    },
    onlyOne: {
      type: Boolean,
      default: false,
    },
    plSugerido: {
      type: Number,
      default: 0,
    },
    plNaoAlocado: {
      type: Number,
      default: null,
    },
    fixados: {
      type: Array,
      default: [],
    },
    ativosAtuais: {
      type: Array,
      default: () => null,
    },
    janelaTempo: {
      type: Number,
      default: 6,
    },
    classes: {
      type: Array,
      default: () => {
        return []
      },
    },
    qualificado: Boolean,
  },
  data() {
    return {
      getNumber,
      busModal: new Vue(),
      loading: false,
      loadingAssets: false,
      ativos: [],
      ativosSelecionados: [],
      tipos: [],
      CLASSES_SIMULADOR: CLASSES_SIMULADOR,
      searchAsset: '',
      filtro: {
        classe: 'Todas',
        tipo: 'Todos',
        utilizar: 'Todos',
        subclasse: 'Todas',
      },
      modo_unico_ativos: '',
      showSubclass: false,
      hideAlerts: false,
      headers: [
        {
          text: 'Ativo',
          align: 'left',
          value: 'nome_ativo',
          width: 260,
        },
        {
          text: 'Classe',
          align: 'left',
          value: 'classe',
          width: 200,
        },
        {
          text: 'Subclasse',
          align: 'left',
          value: 'subclasse',
          width: 200,
        },
        {
          text: 'Na base',
          value: 'utilizar',
          width: 80,
        },
        {
          text: 'Setor',
          value: 'setor',
          width: 160,
        },
        {
          text: 'Recomendação',
          value: 'recomendacao',
          width: 130,
        },
        {
          text: 'Tags',
          value: 'tags',
          width: 180,
        },
        {
          text: 'Comentário',
          value: 'comentario',
          width: 120,
        },
      ],
      sortBy: [],
      itensPorPagina: 10,
      paginaAtual: 1,
      totalResult: 0,
      sortDesc: [],
      timeoutSearchName: null,
      timeoutLoadAssets: null,
      recomendacaoLabels: RECOMENDACAO_LABELS,
      recomendacaoTextColors: RECOMENDACAO_TEXT_COLORS,
    }
  },
  computed: {
    usuarioAtual() {
      return store.getters['user/currentUser'] || {}
    },
    ativosFiltrados() {
      const f = this.filtro
      return this.ativos.filter((a) => {
        return (
          (!f.classe.length || f.classe.includes(a.classe)) &&
          (!f.tipo.length || f.tipo.includes(a.tipo)) &&
          (f.utilizar === 'Todos' ||
            (f.utilizar === 'Sim' ? a.utilizar : !a.utilizar))
        )
      })
    },
    paginationOffset() {
      return (this.paginaAtual - 1) * this.itensPorPagina
    },
    subclasses() {
      return this.$store.getters['subclasse/listagem']
    },
  },
  watch: {
    searchAsset(newValue, oldValue) {
      if (newValue != oldValue) {
        clearTimeout(this.timeoutSearchName)
        this.timeoutSearchName = setTimeout(() => {
          this.loadAssets()
        }, 300)
      }
    },
  },
  created() {
    this.bus.$on(MODAL.SEARCH_ASSET_LONG, this.open)
  },
  beforeDestroy() {
    this.bus.$off(MODAL.SEARCH_ASSET_LONG, this.open)
  },
  methods: {
    clearSearch() {
      this.searchAsset = ''
      this.filtro = {
        classe: 'Todas',
        tipo: 'Todos',
        utilizar: 'Todos',
        subclasse: 'Todas',
      }
    },
    open(ativosShort, opts) {
      this.clearSearch()
      this.ativosSelecionados = []
      if (opts) {
        this.modo_unico_ativos = opts.modo
        this.showSubclass = opts.showSubclass
        this.hideAlerts = opts.hideAlerts
      } else {
        this.modo_unico_ativos = ''
        this.showSubclass = false
        this.hideAlerts = false
      }
      if (ativosShort && ativosShort.length) {
        this.ativosSelecionados = ativosShort
      }

      this.tipos = TIPOS_CONFIG_ATIVOS.map((t) => {
        return t.tipo
      })

      this.$store.dispatch('subclasse/carregar')

      this.loadAssets()

      this.busModal.$emit('dialog', true)
    },
    /**
     * Resetando os filtros da tabela.
     */
    clearFilters() {
      this.paginaAtual = 1
      this.sortBy = ''
      this.sortDesc = false
      this.selectAllAssets = false
    },
    loadAssets(ignore_loading) {
      clearTimeout(this.timeoutLoadAssets)
      this.timeoutLoadAssets = setTimeout(() => {
        this._loadAssets(ignore_loading)
      }, 300)
    },
    async _loadAssets(ignore_loading) {
      console.info('Entrando no loading dos ativos')
      const opts = {
        text: encodeURIComponent(this.searchAsset),
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
      }

      if (this.loadingAssets && !ignore_loading) {
        return
      }

      this.loadingAssets = true

      let url =
        configuracoes.ativos.manage +
        `?tipo=all&limit=${this.itensPorPagina}&offset=${this.paginationOffset}`

      if (opts.text && opts.text.length >= 3) {
        url += `&matches={"nome_ativo":"${opts.text}","referencia":"${opts.text}"}`
        this.sortBy = ''
      }

      if (opts.sortBy && !(opts.text && opts.text.length >= 3)) {
        if (typeof opts.sortBy === 'string') {
          url += `&sort={"${opts.sortBy}${
            ['nome_ativo', 'classe', 'referencia'].includes(opts.sortBy)
              ? '.keyword'
              : ''
          }":"${
            (
              typeof opts.sortDesc === 'object'
                ? opts.sortDesc[0]
                : opts.sortDesc
            )
              ? 'desc'
              : 'asc'
          }"}`
        } else {
          if (opts.sortBy[0]) {
            url += `&sort={"${opts.sortBy[0]}${
              ['nome_ativo', 'classe', 'referencia'].includes(opts.sortBy)
                ? '.keyword'
                : ''
            }":"${
              (
                typeof opts.sortDesc === 'object'
                  ? opts.sortDesc[0]
                  : opts.sortDesc
              )
                ? 'desc'
                : 'asc'
            }"}`
          }
        }
      }

      if (
        this.filtro.classe != 'Todas' ||
        this.filtro.tipo != 'Todos' ||
        this.filtro.utilizar != 'Todos' ||
        this.filtro.subclasse != 'Todas'
      ) {
        let aux = { ...this.filtro }
        if (this.filtro.classe === 'Todas') {
          delete aux.classe
        }
        if (this.filtro.subclasse === 'Todas') {
          delete aux.subclasse
        }
        if (this.filtro.tipo === 'Todos') {
          delete aux.tipo
        }
        if (this.filtro.utilizar === 'Todos') {
          delete aux.utilizar
        } else {
          aux.utilizar = aux.utilizar === 'Sim'
        }

        if (Object.values(aux).length) {
          url += `&filters=${encodeURIComponent(JSON.stringify(aux))}`
        }
      }

      const r = await con.get(url)

      if (r && r.status === 200) {
        this.ativos = possivelJSON(r.value.ativos)
        this.totalResult = r.value.metadata.value
      } else {
        this.ativos = []
        this.totalResult = 0
      }

      this.loadingAssets = false
    },
    async enviar() {
      this.bus.$emit('select-assets', this.ativosSelecionados)
      this.busModal.$emit('dialog', false)
    },
    // openNewAsset() {
    //   console.log('Abrir novo ativo')
    // },
    openEdit(asset) {
      this.busModal.$emit(
        MODAL.SIMULATOR_EDIT_ASSET,
        { ...asset },
        {
          modo: this.modo_unico_ativos,
          openClass: this.openClass,
          showSubclass: this.showSubclass,
          hideAlerts: this.hideAlerts,
          callback: (a) => {
            const index = this.ativosSelecionados.findIndex((a) => {
              return a.nome_ativo === asset.nome_ativo
            })
            if (index >= 0) {
              this.$set(this.ativosSelecionados, index, a)
            } else {
              this.ativosSelecionados.push(a)
            }
            if (this.onlyOne) {
              this.enviar()
            }
          },
        }
      )
    },
    selectAsset(asset) {
      const existente = [...this.fixados, ...this.ativosSelecionados].find(
        (a) => {
          return asset.nome_ativo === a.nome_ativo
        }
      )
      if (existente) {
        this.$showSnack({
          text: 'Este ativo já esta fixado',
          button: true,
        })
      } else {
        // Removendo possíveis valores antigos para R$ e % do ativo, já que está
        // tentando inserir um novo.
        // Motivo: Tentar adicionar um ativo no Portfólio Modelo.
        asset.pl = 0
        asset.percentual = 0
        this.busModal.$emit(
          MODAL.SIMULATOR_EDIT_ASSET,
          { ...asset },
          {
            modo: this.modo_unico_ativos,
            openClass: this.openClass,
            showSubclass: this.showSubclass,
            hideAlerts: this.hideAlerts,
            callback: (a) => {
              this.ativosSelecionados.push(a)
              if (this.onlyOne) {
                this.enviar()
              }
            },
          }
        )
      }
    },
    /**
     * Remover um ativo da lista de ativos selecionados.
     */
    deselect(asset) {
      this.ativosSelecionados = this.ativosSelecionados.filter((a) => {
        return a.nome_ativo !== asset.nome_ativo
      })
    },
    getRecomendacaoLabel(recomendacao) {
      return this.recomendacaoLabels[recomendacao] || recomendacao
    },
    getRecomendacaoStatusColor(recomendacao) {
      return this.recomendacaoTextColors[recomendacao] || '#7C89B7'
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="1320px" persistent>
    <Title title="Lista completa" />
    <div class="row">
      <div :class="ativosSelecionados.length ? 'col-8' : 'col-12'">
        <div class="d-flex row mb-0 pb-0">
          <v-select
            v-model="filtro.tipo"
            class="col-3 pb-0"
            label="Tipo"
            :items="['Todos', ...tipos]"
            @change="loadAssets(true)"
          >
          </v-select>
          <v-select
            v-model="filtro.classe"
            label="Classe"
            class="col-3 pb-0"
            :items="['Todas', ...CLASSES_SIMULADOR]"
            @change="loadAssets(true)"
          >
          </v-select>
          <v-select
            v-model="filtro.subclasse"
            label="Subclasse"
            class="col-3 pb-0"
            :items="['Todas', ...subclasses]"
            item-text="subclasse"
            item-value="subclasse"
            @change="loadAssets(true)"
          ></v-select>
          <v-select
            v-model="filtro.utilizar"
            class="col-3 pb-0"
            label="Na base"
            :items="['Todos', 'Sim', 'Não']"
            @change="loadAssets(true)"
          >
          </v-select>
        </div>
        <form action="#" class="my-5" @submit.prevent>
          <div class="input-group align-items-center">
            <v-text-field
              v-model="searchAsset"
              class="input short-search"
              append-icon=" "
              background-color="#E4E0E6"
              item-value="id"
              item-text="name"
              label=""
              full-width
              placeholder="Pesquisar"
            >
            </v-text-field>
            <button
              class="btn btn-icon btn-icon-secondary align-self-center"
              :style="{
                'background-color': '#E4E0E6',
              }"
            >
              <icon-svg color="#7C89B7" size="18" name="status-search" />
            </button>
          </div>
        </form>

        <div class="tabela-ativos">
          <v-data-table
            style="background: transparent"
            height="220"
            fixed-header
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            item-key="id_ativo"
            :items="ativos"
            :headers="headers"
            :loading="loadingAssets"
            :items-per-page.sync="itensPorPagina"
            :footer-props="{
              'items-per-page-options': [10, 50, 100, 250],
            }"
            :server-items-length="totalResult"
            :page="paginaAtual"
            class="table-pointer"
            @update:page="
              paginaAtual = $event
              loadAssets(true)
            "
            @update:items-per-page="
              itensPorPagina = $event
              loadAssets(true)
            "
            @update:sort-by="loadAssets(true)"
            @update:sort-desc="loadAssets(true)"
            @click:row="selectAsset"
          >
            <template v-slot:item.aberto="{ value }">
              <v-icon small :color="value ? 'success' : 'red'">
                {{ value ? 'mdi-lock-open-outline' : 'mdi-lock-outline' }}
              </v-icon>
            </template>
            <template v-slot:item.utilizar="{ value }">
              <div :class="{ 'text-success': value }">
                {{ value ? 'Sim' : 'Não' }}
              </div>
            </template>
            <template v-slot:item.nome_ativo="{ value }">
              <div class="asset-name-cell">{{ value || '-' }}</div>
            </template>
            <template v-slot:item.recomendacao="{ value }">
              <BaseStatus
                v-if="value"
                soft
                :content="getRecomendacaoLabel(value)"
                :color="getRecomendacaoStatusColor(value)"
              />
              <small v-else>-</small>
            </template>
            <template v-slot:item.setor="{ value }">
              <small>{{ value || '-' }}</small>
            </template>
            <template v-slot:item.tags="{ value }">
              <ClientTags
                v-if="Array.isArray(value) && value.length"
                :tags="value"
                :max-tags-display="2"
                color-mode="fixed"
                use-small-chips
              />
              <small v-else>-</small>
            </template>
            <template v-slot:item.comentario="{ value }">
              <icon-svg
                :color="value ? 'var(--primary)' : '#A4A4A4'"
                size="16"
                name="message-time"
              />
            </template>
          </v-data-table>
        </div>
      </div>

      <div v-if="ativosSelecionados.length" class="col-4">
        <p class="subhead text-bold"> Ativos selecionados </p>
        <v-divider />
        <v-list>
          <v-list-item-group style="max-height: 300px; overflow-y: auto">
            <v-list-item
              v-for="a in ativosSelecionados"
              :key="a.id_ativo"
              @click="openEdit(a)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <div
                    class="d-flex justify-content-between"
                    style="max-width: 100%"
                  >
                    <span class="selected-asset-name">
                      {{ a.nome_ativo || '—' }}
                    </span>
                    <small v-if="getNumber(a.percentual)">
                      {{
                        a.percentual +
                        ((a.percentual || '').toString().includes('%')
                          ? ''
                          : '%')
                      }}
                    </small>
                    <small v-else> {{ a.pl }} </small>
                  </div>
                </v-list-item-title>
                <v-list-item-subtitle>
                  <small> {{ a.classe }} </small>
                </v-list-item-subtitle>
                <hr />
              </v-list-item-content>
              <v-list-item-action class="ml-1">
                <v-btn small icon @click="deselect(a)">
                  <v-icon small> mdi-close </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </div>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close"> Voltar </BaseButton>
      <!-- <BaseButton dark hidden @click="openNewAsset">
        <strong> + </strong> Ativo
      </BaseButton> -->
      <BaseButton primary @click="enviar"> Inserir ativo </BaseButton>
      <v-spacer />
    </template>

    <EditarAtivo
      :bus="busModal"
      :pl-total="plTotal"
      :pl-sugerido="plSugerido"
      :pl-nao-alocado="plNaoAlocado"
      :ativos-atuais="ativosAtuais"
      :janelaTempo="janelaTempo"
      :qualificado="qualificado"
      :classes="classes"
      :ativosSelecionados="ativosSelecionados"
    />
  </BaseModal>
</template>

<style lang="sass" scope>
.table-pointer
  tbody tr:hover
    cursor: pointer
    background-color: var(--gray-1) !important

.tabela-ativos .v-data-table tbody tr td
  padding-top: 5px
  padding-bottom: 5px

.asset-name-cell
  min-width: 240px
  font-size: 13px
  line-height: 18px
  white-space: normal
  word-break: break-word

.selected-asset-name
  min-width: 180px
  font-size: 13px
  line-height: 18px
  white-space: normal
  word-break: break-word
</style>
